import React from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import Navbar from "./component/Navbar";
import Home from "./component/Home";
import Login from "./component/Login";
import User from "./component/User";
import Loader from "./component/Loader";
import { ChatState } from "./asset/context";

function App() {
const {loading} = ChatState()
  return (
    <div className="App">
    <Navbar/>
    {
      loading?
      <Loader/>:""
    }
    <Routes>
      <Route path="/" element={<Home/>} />
      <Route path="/login" element={<Login/>} />
      <Route path="/contact" element={<User/>} />
    </Routes>
    
    </div>
  );
}

export default App;
